import { render, staticRenderFns } from "./StepsOptionsBody.vue?vue&type=template&id=61cc52f3"
import script from "./StepsOptionsBody.vue?vue&type=script&lang=js"
export * from "./StepsOptionsBody.vue?vue&type=script&lang=js"
import style0 from "./StepsOptionsBody.vue?vue&type=style&index=0&id=61cc52f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports